import Button from "@/components/primitives/button";
import { formatOdd } from "@/utils";
import { useOddsFormat } from "@/utils/providers/odds-format";
import { LineType, Odd, Odd2 } from "common";
import React from "react";

export interface SportsbookOddsCellProps {
  gameId: number;
  odd?: Odd2;
  sportsbookUrl?: string;
  className?: string;
  dark?: boolean;
}

export default function SportsbookOddsCell(props: SportsbookOddsCellProps) {
  const { oddsFormat } = useOddsFormat();
  const formattedOdd = formatOdd(oddsFormat, props.odd);

  return (
    <a
      href={props.sportsbookUrl}
      target="_blank"
      className={`group flex w-[5.0625rem] h-9 relative z-0 overflow-hidden gap-1 items-center rounded-md text-title-bold p-2 justify-center ${
        props.dark
          ? "bg-[#3A3C3F] text-white hover:text-secondary-200 hover:bg-primary-500"
          : "bg-surface-500 text-secondary-100 hover:bg-primary-500"
      }`}
    >
      {props.odd === undefined ||
      props.odd.value === 0 ||
      props.odd.value === null ? (
        <div className="w-full text-label-lg-bold text-secondary-600 text-center">
          TBD
        </div>
      ) : (
        <>
          <span className="normal-case tracking-[0.06px]">
            {formattedOdd?.type === LineType.Moneyline ? formattedOdd?.payout : formattedOdd?.value}
          </span>
          <div
            className={`text-label-lg-bold ${
              props.dark ? "text-secondary group-hover:text-grey" : "text-grey"
            }`}
          >
            {props.odd.type !== LineType.Moneyline && (
              <span className="normal-case">
                {formattedOdd?.payout}
              </span>
            )}
          </div>
        </>
      )}
    </a>
  );
}
